'user strict'
const Sequelize = require('../config/db')
const uploadFile = require('../services/uploadFile')
const fs = require('fs');
const excel = require('exceljs')
const ex = require('../lib/error')

const A = 'A';
const B = 'B';

const LOCAL_LOGOPATH = __dirname + "/../../public/logo/" 
const LOCAL_SIGNATUREPATH = __dirname + "/../../public/signature/"
const LOCAL_BILLPDFPATH = __dirname + "/../../public/billpdfs/"
const GCLOUD_LOGOPATH = "destination/"
const GCLOUD_SIGNATUREPATH = "destination/"
const GCLOUD_BILLPDFPATH = "destination/"
const GCLOUD_BASE_URL = "https://storage.googleapis.com/"
const SUCCESS_COMPANYLOGO = '/home/bbook/public_html/billbook/public/uplaodReports/'
const SUCCESS_SIGNATUREIMAGE = '/home/bbook/public_html/billbook/public/uplaodReports/'
const SUCCESS_BILLPDF = '/home/bbook/public_html/billbook/public/uplaodReports/'
const SAVE_EXCEL = '/home/bbook/public_html/billbook/public/uplaodReports/'
const SAVE_EXCEL_URL = "/daybooks/"
const STAGING_BASE_URL = "api.thebillbook.com"
const LOCAL_BASE_URL = "localhost:3033"


const upload = async (req, res, next) => {

    const id = req.params.id;
    try{
        if(id == 1){
            let companyLogoLists = await Sequelize.query(
                `SELECT users.userid AS id, users.companyLogo AS url FROM users WHERE users.companyLogo LIKE '%${STAGING_BASE_URL}%' LIMIT 250`
                //devapi.thebillbook.com
            )
            const fileName = "CompanyLogo_" + new Date().getTime() + ".xls"
            await uploadImage(req, LOCAL_LOGOPATH, GCLOUD_LOGOPATH, companyLogoLists[0], fileName)
            await updateDatabase(SUCCESS_COMPANYLOGO + fileName, GCLOUD_LOGOPATH, id)
           
        }else if(id == 2){
            let signatureLists = await Sequelize.query(
                `SELECT users.userid AS id, users.signatureImage AS url FROM users WHERE users.signatureImage LIKE '%${STAGING_BASE_URL}%' LIMIT 250`
                //devapi.thebillbook.com
            )
            const fileName = "SignatureImage_"+ new Date().getTime() +".xls"
            await uploadImage(req, LOCAL_SIGNATUREPATH, GCLOUD_SIGNATUREPATH, signatureLists[0], fileName)
            await updateDatabase(SUCCESS_SIGNATUREIMAGE + fileName, GCLOUD_SIGNATUREPATH, id)
        }else if(id == 3){
            let pdfLists = await Sequelize.query(
                `SELECT invoices.id AS id, invoices.pdfLink AS url FROM invoices WHERE invoices.pdfLink LIKE '%${STAGING_BASE_URL}%' LIMIT 250`
                //devapi.thebillbook.com
            )
            const fileName = "BillPdfs_" + new Date().getTime() + ".xls"
            await uploadImage(req, LOCAL_BILLPDFPATH, GCLOUD_BILLPDFPATH, pdfLists[0], fileName)
            await updateDatabase(SUCCESS_BILLPDF + fileName, GCLOUD_BILLPDFPATH, id)
        }
        next()
    } catch(error){
        ex.raiseError(req, res, error.name, 500, error);
    }
}

const check = async (dest) => {
    return new Promise((resolve, reject) => {
        return fs.access(dest, (err) => {
          if (err) {
            resolve(false)
          }
          resolve(true)
        })
      })
}

const uploadImage = async (req, LOCAL_PATH, GCLOUD_PATH, lists, fileName) => {
    const workbook = new excel.Workbook();
    const successLogo = workbook.addWorksheet('Success');
    const errorLogo = workbook.addWorksheet('Error');

    let successRowNo = 1, errorRowNo = 1;

    const array = Object.values(JSON.parse(JSON.stringify(lists)));
   
    for(let i = 0;i < array.length; i++){
        const path = array[i].url
        const dest = LOCAL_PATH  + path.substring(path.lastIndexOf('/') + 1)
        const destPath = GCLOUD_PATH + dest.substring(dest.lastIndexOf('/') + 1)
        let checker = check(dest);
        checker = await Promise.all([checker])
        if(!checker[0]){
            errorLogo.getCell(A + errorRowNo).value = array[i].id;
            await Sequelize.query(`UPDATE invoices SET invoices.pdfLink = NULL WHERE invoices.id = ${array[i].id}`);
            errorRowNo++;
        }else{
            successLogo.getCell(A + successRowNo).value = array[i].id; 
            successLogo.getCell(B + successRowNo).value = array[i].url; 
            successRowNo++;
            let publicUrl = uploadFile(dest, destPath)
            publicUrl = await Promise.all([publicUrl])
        }
    }
    await workbook.xlsx.writeFile(SAVE_EXCEL + fileName)
    req.responseObject.data.Link = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + SAVE_EXCEL_URL + fileName
}

const updateDatabase = async (filePath, GCLOUD_PATH, toggle) => {
    var workbook = new excel.Workbook(); 
    await workbook.xlsx.readFile(filePath)
    .then(function() {
        var worksheet = workbook.getWorksheet(1);
        worksheet.eachRow( function(row, rowNumber) {
            var id, oldUrl;
            row.eachCell(async function(cell, colNumber) {
                if(colNumber == 1){
                    id = cell.value
                }else if(colNumber == 2){
                    oldUrl = cell.value
                    let newUrl = GCLOUD_BASE_URL + GCLOUD_PATH + oldUrl.substring(oldUrl.lastIndexOf('/') + 1);
                    if(toggle == 1){
                        await Sequelize.query(
                            `UPDATE users SET users.companyLogo = "${newUrl}" WHERE users.userid = ${id}`
                        )
                    }else if(toggle == 2){
                        await Sequelize.query(
                            `UPDATE users SET users.signatureImage = "${newUrl}" WHERE users.userid = ${id}`
                        )
                    }else if(toggle == 3){
                        await Sequelize.query(
                            `UPDATE invoices SET invoices.pdfLink = "${newUrl}" WHERE invoices.id = ${id}`
                        )
                    }
                }
            });
        });
    });
}

const populateImage = async (req, res, next) => {

    let users = await Sequelize.query(
        `SELECT users.userid FROM users`
    ) 

    const array = Object.values(JSON.parse(JSON.stringify(users[0])));

    for(let i = 0;i < array.length; i++){
        fs.writeFile(`./public/logo/${"logo" + array[i].userid}.png`, '', () => { });
        fs.writeFile(`./public/signature/${"sign" + array[i].userid}.png`, '', () => { });
    }

    for(let i = 0; i < array.length; i++){
        let filename = array[i].userid;
        let logoNewUrl =  "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/logo/" + "logo" + filename + ".png"
        let signatureNewUrl = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/signature/" + "sign" + filename + '.png'
        await Sequelize.query(
            `UPDATE users SET users.companyLogo = "${logoNewUrl}" WHERE users.userid = ${array[i].userid}`,
        )
        await Sequelize.query(
            `UPDATE users SET users.signatureImage = "${signatureNewUrl}" WHERE users.userid = ${array[i].userid}`
        )    
    }
    next()
}

const populateBillPdfs = async (req, res, next) => {

    let invoices = await Sequelize.query(
        `SELECT invoices.id FROM invoices`
    ) 

    const array = Object.values(JSON.parse(JSON.stringify(invoices[0])));

    for(let i = 0;i < array.length; i++){
        fs.writeFile(`./public/billpdfs/${"billPdfs" + array[i].id}.png`, '', () => { });
    }

    for(let i = 0; i < array.length; i++){
        let filename = "billPdfs" + array[i].id;
        let billPdfNewUrl =  "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/billpdfs/" + filename + ".png"
        await Sequelize.query(
            `UPDATE invoices SET invoices.pdfLink = "${billPdfNewUrl}" WHERE invoices.id = ${array[i].id}`,
        )  
    }
    next()
}

module.exports = {
    upload,
    uploadImage,
    updateDatabase,
    populateImage,
    populateBillPdfs,
}
